import { Component, EventEmitter, Input, Output } from '@angular/core';

// "Chat history" card in the right panel (specs/ai-agent-home-redesign US-14, US-18). Show asks the
// parent to open the chat history pop-up (AgentChatHistoryDialogComponent).
@Component({
  selector: 'app-agent-chat-history',
  templateUrl: './agent-chat-history.component.html',
  styleUrls: ['./agent-chat-history.component.scss'],
})
export class AgentChatHistoryComponent {
  @Input() agentName = '';
  @Output() show = new EventEmitter<void>();
}
